import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  TextField
} from '@mui/material'
import { useStore } from 'effector-react'
import React from 'react'
import { $departmentTable } from '..'
import { sendParameters } from '../../../common/functions'
import TaskWrapper from './TaskWrapper'

export default function InitTask({ task, isCanceled }) {
  const departmentTable = useStore($departmentTable)

  const [departmentId, setDepartmentId] = React.useState(
    task.meta?.departmentId || null
  )
  const [isEmergency, setIsEmergency] = React.useState(
    task.meta?.isEmergency || false
  )
  const [isMunicipal, setIsMunicipal] = React.useState(
    task.meta?.isMunicipal || false
  )
  const handleIsEmergencyChange = () => {
    setIsEmergency((value) => !value)
  }
  const handleIsMunicipalChange = () => {
    setIsMunicipal((value) => !value)
  }

  const enabled = task.isActive && task.accessFlags.update && !isCanceled

  return (
    <TaskWrapper
      task={task}
      label="Параметры"
      isCanceled={isCanceled}
      onSave={() =>
        sendParameters(task.paidServiceId, task.id, {
          departmentId: departmentId,
          isEmergency: isEmergency,
          isMunicipal: isMunicipal
        })
      }
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <FormControl sx={{ width: 260 }}>
          <TextField
            value={departmentId}
            onChange={(e) => setDepartmentId(e.target.value)}
            select
            label="Выберите отдел"
            size="small"
            disabled={!enabled}
          >
            {departmentTable?.data?.length > 0 &&
              departmentTable?.data?.map(({ name, id }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
          </TextField>
        </FormControl>
        <FormControlLabel
          control={
            <Checkbox
              checked={isEmergency}
              value={isEmergency}
              disabled={!enabled}
              onChange={handleIsEmergencyChange}
            />
          }
          label="Аварийная заявка"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isMunicipal}
              value={isMunicipal}
              disabled={!enabled}
              onChange={handleIsMunicipalChange}
            />
          }
          label="Бюджетники"
        />
      </Box>
    </TaskWrapper>
  )
}
